/** @format */

export function removeAcento(str) {
  var defaultDiacriticsRemovalMap = [
    {
      base: "A",
      letters:
        /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g,
    },
    {
      base: "E",
      letters:
        /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g,
    },
    {
      base: "I",
      letters:
        /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g,
    },
    {
      base: "O",
      letters:
        /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g,
    },
    {
      base: "U",
      letters:
        /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g,
    },
    {
      base: "C",
      letters:
        /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g,
    },
  ];

  for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(
      defaultDiacriticsRemovalMap[i].letters,
      defaultDiacriticsRemovalMap[i].base,
    );
  }

  return str;
}

export const defineTopeteRecomendacao = (id_topete) => {
  if (id_topete === "") {
    return "";
  }

  if (id_topete === "1") {
    return "Destaque";
  }

  if (id_topete === "2") {
    return "Para você";
  }

  if (id_topete === "3") {
    return "Para você";
  }
};

export function validaValidadede({ validadede }) {
  const validade = new Date(validadede);
  const hoje = new Date();

  if (validade > hoje) {
    return true;
  } else {
    return false;
  }
}

export function formatRecomendacao(recomendacao, hasDestaques, ordenacao = ["random"]) {
  let descontoExclusivo = [];
  let dinheiroDeVolta = [];
  let ofertas = [];
  let destaques = [];

  // Se eu não tiver destaques
  if (!hasDestaques) {
    descontoExclusivo = recomendacao.filter(
      (data) => data.idtiporecomendacao === "1",
    );
    ofertas = recomendacao.filter((data) => data.idtiporecomendacao === "2");
    dinheiroDeVolta = recomendacao.filter(
      (data) => data.idtiporecomendacao === "3",
    );
  } else {
    descontoExclusivo = recomendacao.filter(
      (data) =>
        data.idtiporecomendacao === "1" &&
        data.id_classificacao_topete !== "1" &&
        data.id_classificacao_topete !== "3",
    );
    ofertas = recomendacao.filter(
      (data) =>
        data.idtiporecomendacao === "2" &&
        data.id_classificacao_topete !== "1" &&
        data.id_classificacao_topete !== "3",
    );
    dinheiroDeVolta = recomendacao.filter(
      (data) =>
        data.idtiporecomendacao === "3" &&
        data.id_classificacao_topete !== "1" &&
        data.id_classificacao_topete !== "3",
    );
    destaques = recomendacao.filter(
      (data) =>
        data.id_classificacao_topete === "1" ||
        data.id_classificacao_topete === "3",
    );
  }

  let _format = {
    descontoExclusivo: descontoExclusivo,
    ofertas: ofertas,
    dinheiroDeVolta: dinheiroDeVolta,
    destaques: ordenaRecomendacoes(destaques, ordenacao),
  };

  return _format;
}

export function formatDataAtivacao(string, horizontal) {
  let date = new Date(string.split(" ")[0]).toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });
  let hour =
    string.split(" ")[1].split(":")[0] +
    ":" +
    string.split(" ")[1].split(":")[1];

  if (!horizontal) {
    return date;
  } else {
    return date + " " + hour;
  }
}

export function dataAtualUTC() {
  const datePartOne = new Date().toJSON().split("T")[0];
  const datePartTwo = new Date().toJSON().split("T")[1];
  const dateFormat = datePartOne + "T" + datePartTwo.split("Z")[0] + "+03:00";
  const dataAtual = new Date(dateFormat);
  return dataAtual;
}

export function formataEventosDeTela(url) {
  const pathFormatado = url.split("/");

  if (pathFormatado[1] === "") {
    return "telaofertas";
  }
  if (pathFormatado[1] === "vermais" && pathFormatado[2] === "tabloide") {
    return "listaofertastabloide";
  }
  if (
    pathFormatado[1] === "vermais" &&
    pathFormatado[2] === "descontoexclusivo"
  ) {
    return "listaofertasdesconto";
  }
  if (pathFormatado[1] === "vermais" && pathFormatado[2] === "cashback") {
    return "listaofertascashback";
  }
  if (pathFormatado[1] === "descricao") {
    return "detalhesoferta";
  }
  if (pathFormatado[1] === "filtros") {
    return "teladefiltros";
  }
}

export function formataEventosFiltros(ids) {
  if (ids.includes(1)) {
    return "filtrodescontoexclusivo";
  }
  if (ids.includes(2)) {
    return "filtrocashback";
  }
  if (ids.includes(3)) {
    return "filtrotabloide";
  }
  if (ids.includes(4)) {
    return "filtrodestaque";
  }
  if (ids.includes(5)) {
    return "filtrorelevante";
  }
  if (ids.includes(6)) {
    return "filtroclube";
  }
  if (ids.includes(7)) {
    return "filtroexpiraembreve";
  }
  if (ids.includes(8)) {
    return "filtroofertasativadas";
  }
}

export function intercale(array1, array2, array3) {
  var arrayResult = [];
  var total = 0;
  if (array1.length > array2.length && array1.length > array3.length) {
    total = array1.length;
  } else if (array2.length > array1.length && array2.length > array3.length) {
    total = array2.length;
  } else {
    total = array3.length;
  }

  for (var i = 0; i < total; i++) {
    if (array1[i]) {
      arrayResult.push(array1[i]);
    }
    if (array2[i]) {
      arrayResult.push(array2[i]);
    }
    if (array3[i]) {
      arrayResult.push(array3[i]);
    }
  }

  return arrayResult;
}

export const ordenaRecomendacoes = (
  recomendacao = [],
  ordenacao = ["random"]
) => {
  let newOrdenacao =
    ordenacao.length === 0 || ordenacao === undefined || ordenacao === null
      ? ["random"]
      : ordenacao;
  let newRecomendacao = [];

  if (recomendacao.length > 0) {
    if (newOrdenacao.includes("random")) {
      newRecomendacao = recomendacao;
    } else {
      for (let i = 0; i < newOrdenacao.length; i++) {
        if (newOrdenacao[i] === "Desconto exclusivo") {
          newRecomendacao = [
            ...newRecomendacao,
            ...recomendacao.filter((recomendacao) => recomendacao.idtiporecomendacao === "1"),
          ];
        } else if (newOrdenacao[i] === "Ofertas") {
          newRecomendacao = [
            ...newRecomendacao,
            ...recomendacao.filter((recomendacao) => recomendacao.idtiporecomendacao === "2"),
          ];
        } else {
          newRecomendacao = [
            ...newRecomendacao,
            ...recomendacao.filter((recomendacao) => recomendacao.idtiporecomendacao === "3"),
          ];
        }
      }
    }
  }

  return newRecomendacao;
};

export function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}
